import { Dispatch } from 'redux';
import { isEmpty } from 'lodash';
import { locationActions } from '../slices/location-slice';
import { ApiLocation } from '../http';

const {
  setLocationRequestStart,
  setLocationRequestSuccess,
  setLocationRequestFailure,
  setLocationRequestDefault,

  setLocationListRequest,
  setLocationListSuccess,
  setLocationListFailure,
  setLocationListDefault,

  setLocationOneRequest,
  setLocationOneSuccess,
  setLocationOneFailure,
  setLocationOneDefault,

  setLocationWarehouseRequest,
  setLocationWarehouseSuccess,
  setLocationWarehouseFailure,
  setLocationWarehouseDefault,
} = locationActions;

//List
export const getLocations = (params: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setLocationListRequest());
  try {
    const data = await ApiLocation.fetchAll(params);
    dispatch(setLocationListSuccess(data));
  } catch ({ message }) {
    dispatch(setLocationListFailure({ message }));
  }
};
export const clearLocations = () => async (dispatch: Dispatch<any>) => {
  dispatch(setLocationListDefault());
};

//One
export const getLocation = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setLocationOneRequest());
  try {
    const data = await ApiLocation.fetchOne(id);
    dispatch(setLocationOneSuccess(data));
  } catch ({ message }) {
    dispatch(setLocationOneFailure({ message }));
  }
};
export const clearLocation = () => async (dispatch: Dispatch<any>) => {
  dispatch(setLocationOneDefault());
};

//Warehouse
export const forceGetLocationWarehouse = () => async (dispatch: Dispatch<any>) => {
  dispatch(setLocationWarehouseRequest());
  try {
    const data = await ApiLocation.fetchAll({ take: 9999 });
    dispatch(setLocationWarehouseSuccess(data));
  } catch ({ message }) {
    dispatch(setLocationWarehouseFailure({ message }));
  }
};
export const getLocationWarehouse = () => async (dispatch: Dispatch<any>, getState: any) => {
  const storeStates = getState();
  const { warehouse } = storeStates.location;
  if (isEmpty(warehouse.hits) && !warehouse.isLoading) {
    dispatch(forceGetLocationWarehouse());
  }
};
export const clearLocationWarehouse = () => async (dispatch: Dispatch<any>) => {
  dispatch(setLocationWarehouseDefault());
};

//Create
export const createLocation = (data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setLocationRequestStart());
  return new Promise((resolve, reject) => {
    if (data.placeCount) data.placeCount = parseInt(data.placeCount);
    ApiLocation.createOne(data)
      .then((res) => {
        dispatch(setLocationRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setLocationRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Edit
export const editLocation =
  (id: string | number, data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setLocationRequestStart());
    return new Promise((resolve, reject) => {
      if (data.placeCount) data.placeCount = parseInt(data.placeCount);
      ApiLocation.updateOne(id, data)
        .then((res) => {
          dispatch(setLocationRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setLocationRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Delete
export const deleteLocation = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setLocationRequestStart());
  return new Promise((resolve, reject) => {
    ApiLocation.deleteOne(id)
      .then((res) => {
        dispatch(setLocationRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setLocationRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Clear request
export const clearLocationRequest = () => async (dispatch: Dispatch<any>) => {
  dispatch(setLocationRequestDefault());
};
